module.exports = __webpack_public_path__ + "img/icons8-suzuki.7b9734a8.svg";